import React, { useState, useMemo } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import { Card, Snackbar, Alert } from "@mui/material";
import HeaderSchedule from "./components/HeaderSchedule";
import { historialPermitidoPorNombre } from "./historyAccess";

const Cierre = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Lista de roles administradores
  const ADMIN_ROLES = useMemo(
    () => ({
      // Rol de administrador principal (ID 10)
      ADMIN_ISERRA100: { id: 10, name: "Admin iserra100" },
      // Rol de gerencia (ID 14)
      GERENCIA: { id: 14, name: "Admin iserra100 Gerencia" },
      // Rol de supervisor (ID 15)
      SUPERVISOR: { id: 15, name: "Admin iserra100 Supervisor" },
    }),
    []
  );

  // Analizar datos del localStorage para determinar si es admin
  const isAdmin = useMemo(() => {
    try {
      const userData = localStorage.getItem("user");

      if (!userData) {
        return false;
      }

      const parsed = JSON.parse(userData);

      let roleObj = null;
      let roleName = "";
      let roleId = null;

      if (parsed.user?.role) {
        roleObj = parsed.user.role;
      } else if (parsed.role) {
        roleObj = parsed.role;
      } else if (parsed.more?.role) {
        roleObj = parsed.more.role;
      }

      // Extraer información del objeto de rol
      if (roleObj) {
        // Verificar si es un objeto con propiedades id y name
        if (typeof roleObj === "object" && roleObj !== null) {
          roleId = roleObj.id;
          roleName = roleObj.name || "";

          // Verificar si es admin por ID (10, 14 o 15)
          if (
            roleId === ADMIN_ROLES.ADMIN_ISERRA100.id ||
            roleId === ADMIN_ROLES.GERENCIA.id ||
            roleId === ADMIN_ROLES.SUPERVISOR.id
          ) {
            return true;
          }

          // Verificar si es admin por nombre completo
          if (historialPermitidoPorNombre(roleName)) {
            return true;
          }
        } else if (typeof roleObj === "string") {
          // Si el rol es un string, verificar los nombres
          roleName = roleObj;
          const username = (parsed.user?.username || parsed.username || "").toLowerCase();
          if (historialPermitidoPorNombre(roleName) || username === "admin") {
            return true;
          }
        }
      }

      // También verificar por username directo
      const username = (parsed.user?.username || parsed.username || "").toLowerCase();
      if (username === "admin") {
        return true;
      }

      return false;
    } catch (error) {
      console.error("❌ Error analizando datos de usuario:", error);
      return false;
    }
  }, [ADMIN_ROLES]);

  // Obtener rol del usuario actual
  const currentUserRole = useMemo(() => {
    try {
      const userData = localStorage.getItem("user");
      if (!userData) {
        return "No identificado";
      }

      const parsed = JSON.parse(userData);
      let roleObj = null;

      if (parsed.user?.role) {
        roleObj = parsed.user.role;
      } else if (parsed.role) {
        roleObj = parsed.role;
      } else if (parsed.more?.role) {
        roleObj = parsed.more.role;
      }

      if (roleObj) {
        // Si es un objeto con propiedades, devolver el nombre
        if (typeof roleObj === "object" && roleObj !== null) {
          // Mapear ID a nombre completo si es necesario
          if (roleObj.id === ADMIN_ROLES.ADMIN_ISERRA100.id) {
            return "Admin iserra100";
          }
          if (roleObj.id === ADMIN_ROLES.GERENCIA.id) {
            return "Admin iserra100 Gerencia";
          }
          if (roleObj.id === ADMIN_ROLES.SUPERVISOR.id) {
            return "Admin iserra100 Supervisor";
          }
          return roleObj.name || "Rol sin nombre";
        }
        // Si es un string, devolverlo tal cual
        return roleObj;
      }

      return "Usuario";
    } catch (error) {
      console.error("❌ currentUserRole - Error:", error);
      return "Error";
    }
  }, [ADMIN_ROLES]);

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleTurnClosed = async (data) => {
    try {
      setRefreshFlag((prev) => !prev);

      setSnackbar({
        open: true,
        message: `Turno cerrado exitosamente`,
        severity: "success",
      });
    } catch (error) {
      console.error("Error al cerrar turno:", error);
      const errorMessage = error.response?.data?.message || "Error al cerrar el turno";

      setSnackbar({
        open: true,
        message: errorMessage,
        severity: "error",
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor: snackbar.severity === "success" ? "#f0fff4" : "#fff5f5",
            color: snackbar.severity === "success" ? "#276749" : "#c53030",
            border: snackbar.severity === "success" ? "1px solid #c6f6d5" : "1px solid #fed7d7",
            boxShadow: 2,
            "& .MuiAlert-icon": {
              color: snackbar.severity === "success" ? "#276749" : "#c53030",
            },
          }}
        >
          <MDTypography variant="body1" fontWeight="bold">
            {snackbar.severity === "success" ? "¡Éxito!" : "Error"}
          </MDTypography>
          <MDTypography variant="body2">{snackbar.message}</MDTypography>
        </Alert>
      </Snackbar>

      <HeaderSchedule
        onCloseTurn={handleTurnClosed}
        refreshFlag={refreshFlag}
        currentUserRole={currentUserRole}
        isAdmin={isAdmin}
        onError={(error) => {
          if (error) {
            setSnackbar({
              open: true,
              message: error,
              severity: "error",
            });
          }
        }}
      />
    </DashboardLayout>
  );
};

export default Cierre;
